import { graphql } from '../../__generated__';

export const REWARD_SETTING = graphql(`
  query RewardSetting {
    rewardSetting {
      preference
    }
  }
`);

export const SET_REWARD_SETTING = graphql(`
  mutation SetRewardSetting($preference: Boolean) {
    rewardSetting(preference: $preference) {
      result {
        cashAccountId
        preference
      }
      status
      errorMessage
    }
  }
`);
